<template>
  <div>
    <h1 class="main-header">
      <translate translate-context="email_templates">Customize Email Template</translate>
    </h1>

    <CCard>
      <CCardHeader>
        <div class="card-header-actions">
          <CButton color="primary" @click="onClickSave">
            <translate translate-context="form">Save</translate>
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <EmailTemplateForm ref="form" :data="empty" @save="onSave"/>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EmailTemplateForm from './components/EmailTemplateForm.vue'
import { SuccessNotification } from '@/domain/core/exception/exceptions'

export default {
  name: 'NewEmailTemplate',
  components: {
    EmailTemplateForm
  },
  data() {
    return {
      empty: {
        email_type: '',
        delivery_service: 'BrevoAgent',
        enabled: true,
        debug_mode: false,
        bcc_enabled: false,
        bcc_addresses: [],
        sender_address: '',
        sender_name: '',
        template: {},
        translations: {},
        settings: {}
      }
    }
  },
  computed: {
    ...mapGetters('emailTemplates', ['scope']),

    scopeType() {
      return this.$route.meta.scopeType || 'global'
    },

    scopeId() {
      if (this.scopeType === 'pica-service') {
        return this.$route.params.picaServiceId
      }
      if (this.scopeType === 'contract-manager') {
        return this.$route.params.contractManagerId
      }
      if (this.scopeType === 'event-owner') {
        return this.$route.params.eventOwnerId
      }
      return null
    },

    listRouteName() {
      const scopeType = this.$route.meta.scopeType
      const names = {
        'global': 'admin.emailTemplates.list',
        'contract-manager': 'contractManager.emailTemplates.list',
        'event-owner': 'eventOwner.emailTemplates.list',
        'pica-service': 'event.emailTemplates.list'
      }
      return names[scopeType]
    }
  },
  async mounted() {
    await this.setScope({ type: this.scopeType, id: this.scopeId })
  },
  methods: {
    ...mapActions('emailTemplates', ['createEmailTemplate', 'setScope']),

    onClickSave() {
      this.$refs.form.onSave()
    },

    async onSave(data) {
      try {
        await this.createEmailTemplate(data)
        await this.$router.push({ name: this.listRouteName })
        throw new SuccessNotification(
          this.$pgettext('email_templates', 'Email template customized successfully!')
        )
      } catch (error) {
        if (error instanceof SuccessNotification) {
          throw error
        }
        // Handle validation errors
        if (error.response && error.response.status === 400) {
          const errors = error.response.data
          if (errors.email_type) {
            this.notifyError(errors.email_type[0])
          } else {
            this.notifyError(this.$pgettext('email_templates', 'Please check the form for errors'))
          }
        } else {
          this.notifyError(this.$pgettext('email_templates', 'Failed to customize template'))
        }
      }
    }
  }
}
</script>

<style scoped>
.main-header {
  margin-bottom: 1.5rem;
}
</style>
